module.exports = __webpack_public_path__ + "static/media/icon-refresh-team-code.e9811966.svg";